import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3abbfed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "gallery"
}
const _hoisted_2 = {
  key: 0,
  class: "gallery__mobile"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "gallery__photo-count"
}
const _hoisted_5 = {
  key: 1,
  class: "gallery__desktop"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "gallery__photo-group"
}
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "gallery__photo-small gallery__photo-last"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gallery__photo-overlay--black" }, null, -1))

import BaseButton from '@/components/BaseButton.vue'
import { FORMATS } from '@/enums/components'
import { MULTIMEDIA_TYPE } from '@/models/multimedia.model'
import { useBreakpoints } from '@/composables/useBreakpoints'
import { MultimediaItem } from '@/models/multimedia.model'
import { computed, PropType, ref } from 'vue'
import { api as viewerApi } from 'v-viewer'


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoGallery',
  props: {
  photos: {
    type: Array as PropType<MultimediaItem[]>,
    required: true,
  },
  showHeaderOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
  /**
   * Hide previous/next buttons and photo count in header only and mobile mode
   */
  hideHeaderOnlyInterface: {
    type: Boolean,
    default: false,
  },
  isShowPhotoGallery: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  emits: ["navigateToService"],
  setup(__props) {

const props = __props



const currentMobilePhotoIndex = ref(0)
const { isMobile } = useBreakpoints()

const photosCount = computed(() => {
  return props.photos.length
})

const reorderedPhotos = computed(() => {
  const photoCopy = Object.assign([], props.photos)
  return photoCopy.sort((a, b) => {
    if (a.type === MULTIMEDIA_TYPE.HEADER) return -1
    if (b.type === MULTIMEDIA_TYPE.HEADER) return 1
    return 0
  })
})

function nextPhoto() {
  if (currentMobilePhotoIndex.value + 1 === photosCount.value) {
    currentMobilePhotoIndex.value = 0
  } else {
    currentMobilePhotoIndex.value += 1
  }
}

function previousPhoto() {
  if (currentMobilePhotoIndex.value === 0) {
    currentMobilePhotoIndex.value = photosCount.value - 1
  } else {
    currentMobilePhotoIndex.value -= 1
  }
}

const showPhotoGallery = (index: number) => {
  viewerApi({
    options: {
      inline: false,
      button: true,
      navbar: true,
      title: false,
      toolbar: true,
      tooltip: true,
      movable: false,
      zoomable: true,
      rotatable: true,
      scalable: true,
      transition: true,
      fullscreen: true,
      keyboard: true,
      initialViewIndex: index,
    },
    images: reorderedPhotos.value.map((photo) => {
      return photo.file ? photo.file : photo.file_src_url
    }),
  })
}



return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return (__props.photos.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isMobile) || __props.showHeaderOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!__props.hideHeaderOnlyInterface && 1 < _unref(photosCount))
                ? (_openBlock(), _createBlock(BaseButton, {
                    key: 0,
                    icon: "chevron-left",
                    format: _unref(FORMATS).SECONDARY,
                    "icon-size": 40,
                    class: "gallery__arrow gallery__arrow-previous",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (previousPhoto()))
                  }, null, 8, ["format"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("img", {
                  src: 
            _unref(reorderedPhotos)[currentMobilePhotoIndex.value].file
              ? _unref(reorderedPhotos)[currentMobilePhotoIndex.value].file
              : _unref(reorderedPhotos)[currentMobilePhotoIndex.value].file_src_url
          ,
                  class: "gallery__photo gallery__photo-mobile",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (
            !__props.isShowPhotoGallery
              ? _ctx.$emit('navigateToService')
              : showPhotoGallery(currentMobilePhotoIndex.value)
          ))
                }, null, 8, _hoisted_3), [
                  [
                    _directive_touch,
                    previousPhoto,
                    "swipe",
                    { right: true }
                  ],
                  [
                    _directive_touch,
                    nextPhoto,
                    "swipe",
                    { left: true }
                  ]
                ]),
                (!__props.hideHeaderOnlyInterface)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(currentMobilePhotoIndex.value + 1) + "/" + _toDisplayString(_unref(photosCount)), 1))
                  : _createCommentVNode("", true)
              ]),
              (!__props.hideHeaderOnlyInterface && 1 < _unref(photosCount))
                ? (_openBlock(), _createBlock(BaseButton, {
                    key: 1,
                    icon: "chevron-right",
                    format: _unref(FORMATS).SECONDARY,
                    "icon-size": 40,
                    class: "gallery__arrow gallery__arrow-next",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (nextPhoto()))
                  }, null, 8, ["format"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "gallery__photo gallery__photo-big",
                src: 
          _unref(reorderedPhotos)[0].file
            ? _unref(reorderedPhotos)[0].file
            : _unref(reorderedPhotos)[0].file_src_url
        ,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (
          __props.isShowPhotoGallery ? showPhotoGallery(0) : _ctx.$emit('navigateToService')
        ))
              }, null, 8, _hoisted_6),
              (1 < _unref(photosCount))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reorderedPhotos).slice(
            1,
            _unref(photosCount) > 5 ? 5 : _unref(photosCount),
          ), (photoObject, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: photoObject.id,
                        src: photoObject.file ? photoObject.file : photoObject.file_src_url,
                        class: _normalizeClass(["gallery__photo gallery__photo-small", {
            'gallery__photo--single': _unref(photosCount) === 2,
            'gallery__photo--double': _unref(photosCount) === 3,
            'gallery__photo--triple': _unref(photosCount) === 4,
          }]),
                        onClick: ($event: any) => (
            !__props.isShowPhotoGallery
              ? _ctx.$emit('navigateToService')
              : showPhotoGallery(index + 1)
          )
                      }, null, 10, _hoisted_8))
                    }), 128)),
                    (_unref(photosCount) > 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("h2", {
                            class: "gallery__photo-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (
              !__props.isShowPhotoGallery
                ? _ctx.$emit('navigateToService')
                : showPhotoGallery(4)
            ))
                          }, " +" + _toDisplayString(_unref(photosCount) - 5) + " " + _toDisplayString(_ctx.$t('photos')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})